export var PATHS;
(function (PATHS) {
    PATHS["LANDING"] = "/";
    PATHS["REPORT_TYPE"] = "/report-type";
    PATHS["CHECKOUT"] = "/checkout";
    PATHS["LOGIN"] = "/login";
    PATHS["DEMO"] = "/demo";
    PATHS["FORGOT_PASSWORD"] = "/forgot-password";
    PATHS["RESET_PASSWORD"] = "/reset-password";
    PATHS["LOGIN_ERROR"] = "/login/login-error";
    PATHS["AUTH_ERROR"] = "/auth-error";
    PATHS["HOME"] = "/home";
    PATHS["OVERVIEW"] = "/overview/:assessmentId";
    PATHS["RESULTS"] = "/results/:assessmentId";
    PATHS["ADMIN_DASHBOARD"] = "/admin/dashboard";
    PATHS["TERMS_CONDITIONS_AGREEMENT"] = "/terms-conditions-agreement";
    PATHS["COMMUNITY"] = "/community/:communityId";
    PATHS["NEW_REPORT"] = "/new-report";
    PATHS["REPORT_SETTINGS"] = "/report/:reportId";
    PATHS["INVALID_TOKEN"] = "/invalid-token";
    PATHS["RESTRICTED"] = "/restricted";
    PATHS["EMBED_SIGNUP"] = "/embed/signup";
})(PATHS || (PATHS = {}));
